import React from 'react';
import { SM } from '@zendeskgarden/react-typography';
import { map, includes } from 'lodash';
import { Link } from 'react-router-dom';
import Icon from 'components/Icon/Icon';
import useBreadcrumbs from 'use-react-router-breadcrumbs';
import { variables } from 'theme/variables';
import { titleCase } from './formatStrings';

const { custom_navy: customNavy, custom_slate: customSlate } = variables;

export default function CustomBreadcrumbs({
  omit = [],
  routeOverride,
  origin,
  breadcrumbs,
  disableDefaults = true,
  removeRoot,
  routes,
} = {}) {
  const breadcrumbRoutes = useBreadcrumbs(routeOverride || [routes], {
    disableDefaults,
  });
  let currentBreadcrumbs = breadcrumbs || breadcrumbRoutes;
  if (origin) {
    currentBreadcrumbs = [origin, ...currentBreadcrumbs];
  }
  return map(currentBreadcrumbs, (d, i, arr) => {
    const last = arr.length - 1 === i;
    const link = `${d.key || d.link}${d.suffix || ''}`;
    const title = d.breadcrumb || titleCase(d.title);
    if ((link === '/' && removeRoot) || includes(omit, link)) {
      return null;
    }
    return (
      <span key={`${link || i}-${i}`} style={{ marginRight: '5px' }}>
        <span style={{ marginRight: '5px' }}>
          <Link to={link}>
            <SM
              style={{
                letterSpacing: '1.1px',
                fontSize: '12px',
                color: '#76899e',
              }}
              bold={last}
              as="span"
              link={customNavy}
            >
              {title}
            </SM>
          </Link>
        </span>
        {last ? null : (
          <span>
            <Icon
              icon="icon-chevron-right"
              color={customSlate}
              style={{ padding: '0 10px', display: 'inline' }}
              fontSize="10px"
            />
          </span>
        )}
      </span>
    );
  });
}
